import React, { useState } from 'react';
import { FaFilePdf, FaGithub, FaLinkedin } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';

const Contact = () => {
  const [status, setStatus] = useState(""); 
  const [showTooltip, setShowTooltip] = useState(false); 

  const links = [
    { id: 1, child: <FaLinkedin size={25} />, href: 'https://linkedin.com' },
    { id: 2, child: <FaGithub size={25} />, href: 'https://github.com' },
    { id: 3, child: <HiOutlineMail size={25} />, href: 'mailto:foo@gmail.com' },
    { id: 4, child: <FaFilePdf size={22} />, href: '/UIUXResume.pdf', download: true },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    setShowTooltip(true);

    const formData = new FormData(e.target);

    try {
      const response = await fetch("https://getform.io/f/bbba1146-4c69-4aec-9271-ab15f5bf4eec", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        setStatus("✅ Message sent successfully!");
        e.target.reset();
      } else {
        setStatus("❌ Something went wrong.");
      }
    } catch {
      setStatus("⚠️ Network error.");
    }

    // Hide tooltip after 3 seconds
    setTimeout(() => setShowTooltip(false), 3000);
  };

  return (
 <div
  name="contact"
  className="w-full min-h-screen py-8 sm:py-16 md:py-20 lg:py-24 text-white bg-gradient-to-r from-sky-950 via-slate-800 to-slate-900"
>

      <div className="max-w-screen-lg px-9 py-5 mx-auto flex flex-col justify-center w-full h-full">
        <div>
          <p className="text-4xl font-bold inline border-b-4 border-gray-200">Contact</p>
          <br />
          <p className="py-6">Get in touch with me.</p>
        </div>

        {/* Contact Form */}
        <div className="flex justify-center place-items-center relative">
          <form
            onSubmit={handleSubmit}
            className="flex flex-col w-full md:w-1/2"
          >
            <input
              type="text"
              name="name"
              placeholder="Enter Your Name"
              autoComplete='name'
              required
              className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <input
              type="email"
              name="email"
              placeholder="Enter Your Email"
              autoComplete='email'
              required
              className="p-2 my-4 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <textarea
              name="message"
              rows="10"
              minLength="10"
              maxLength="500"
              placeholder="Enter Your Message"
              required
              className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            ></textarea>

            {/* Button with tooltip */}
            <div className="relative flex justify-center">
              <button
                type="submit"
                className="text-white bg-gradient-to-b from-slate-500 via-slate-400 to-slate-400 px-6 py-2 my-8 flex items-center rounded-md hover:scale-110 duration-300"
              >
                Let's Talk
              </button>

              {/* Tooltip */}
              {showTooltip && (
                <span className="absolute -top-8 bg-slate-700 text-white text-sm px-3 py-1 rounded-md shadow-lg animate-fade-in">
                  {status}
                </span>
              )}
            </div>
          </form>
        </div>
      </div>

      {/* Social Links */}
      <div className="flex flex-row items-center justify-center">
        {links.map(({ id, child, href, download }) => (
          <div key={id} className="lg:hidden flex flex-row w-10 h-10 px-2">
            <a
              href={href}
              className="flex justify-between items-center w-full text-white"
              download={download}
              target="_blank"
              rel="noreferrer"
            >
              {child}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Contact;
